export default function Footer({className, children}) {
  return <div className={className}>{children}</div>;
}

Footer.type = Symbol('Header.Footer');
